export const FIRST_STEP_LAYOUT_HEIGHT = 'calc(100vh - 275px)'

export const FIRST_STEP_WITHOUT_STATS_LAYOUT_HEIGHT = 'calc(100vh - 360px)'

export const PAYMENT_BATCH_CONFIRMATION_TIMEOUT = 10000
